import { LatLngTuple } from 'leaflet';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { IRegion } from 'types/location.js';
import { IMarkerV1 } from 'types/markerTypesV1/marker-v1-type.js';
import { predicateNdArray, predicateNumber } from 'utilities/isType.js';

/** converts polygon 3d into 2d if needed */
export const getPolygon2D = (
  polygons: L.LatLngTuple[][] | L.LatLngTuple[][][] | undefined | null,
): LatLngTuple[][] | undefined => {
  const test3Darray = (polygons: L.LatLngTuple[][] | L.LatLngTuple[][][] | undefined) => {
    const test = polygons?.[0]?.[0]?.[0];
    return predicateNumber(test);
  };
  const newPolyns = predicateNdArray(polygons, test3Darray) ? polygons : polygons?.[0];
  return newPolyns;
};

export const getPolygon = (polygons: L.LatLngTuple[] | L.LatLngTuple[][] | undefined): LatLngTuple[][] | undefined => {
  const test2Darray = (polygons: L.LatLngTuple[] | L.LatLngTuple[][] | undefined) =>
    predicateNumber(polygons?.[0]?.[0]);
  const newPolygons = predicateNdArray(polygons, test2Darray) ? [polygons] : polygons;
  return newPolygons;
};

export const getMarkerPolygons = (
  marker: Pick<IMarkerV1 | IRegion | IWarning, 'polygon' | 'polygons'>,
): L.LatLngTuple[][] => {
  if (marker?.polygons) {
    const newPoly = getPolygon2D(marker.polygons);
    if (newPoly) {
      return newPoly;
    }
  }
  if (marker?.polygon) {
    return [marker.polygon];
  }
  return [[]];
};

export const getCentreOfPolygon = (poly: L.LatLngTuple[]): L.LatLngTuple => {
  const centroid: L.LatLngTuple = [0, 0];
  const totalPolyPoints = poly.length;

  for (let i = 0; i < totalPolyPoints; i++) {
    centroid[0] += poly[i][0]; // lat
    centroid[1] += poly[i][1]; // lng
  }

  centroid[0] = centroid[0] / totalPolyPoints;
  centroid[1] = centroid[1] / totalPolyPoints;

  return centroid;
};

export const isLatLngInPolygonRegion = (latLng: L.LatLngLiteral, poly: L.LatLngTuple[]): boolean => {
  const x = latLng.lat;
  const y = latLng.lng;

  let inside = false;

  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const [xi, yi] = poly[i]; // lat, lng
    const [xj, yj] = poly[j]; // lat, lng

    const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) {
      inside = !inside;
    }
  }

  return inside;
};
